export enum SwiftRMA {
  DEPARTMENT = 'RMA_PROFILE-DEPARTMENT',
  OFFICE = 'RMA_PROFILE-OFFICE',
  REC_STATUS = 'RMA_PROFILE-REC_STATUS',
  PROFILE_CHANGE_STATUS = 'RMA_PROFILE-PROFILE_CHANGE_STATUS',
  EFFECTIVE_DATE = 'EFFECTIVE_DATE',
  V_CORRESPONDENT_BIC = 'RMA_PROFILE-V_CORRESPONDENT_BIC',
  CORRESPONDENT = 'RMA_PROFILE-CORRESPONDENT',
  V_ISSUER_BIC = 'RMA_PROFILE-V_ISSUER_BIC',
  ISSUER = 'RMA_PROFILE-ISSUER',
  START_DATE = 'RMA_PROFILE-START_DATE',
  END_DATE = 'RMA_PROFILE-END_DATE',
  INCLUDED_MSG_CATEGORIES = 'RMA_PROFILE-INCLUDED_MSG_CATEGORIES',
  INCLUDED_SPECIFIC_MTS = 'RMA_PROFILE-INCLUDED_SPECIFIC_MTS',
  EXCLUDED_SPECIFIC_MTS = 'RMA_PROFILE-EXCLUDED_SPECIFIC_MTS',
  MSG_CATEGORY_TP = 'RMA_PROFILE-MSG_CATEGORY_TP',
  TIME_STAMP = 'TIME_STAMP',
  UID = 'VIRTUAL-UID',
  PROFILE_UPDATE_PK = 'PROFILE_UPDATE_PK',
  PU_TIME_STAMP = 'PU_TIME_STAMP',
  NOTE = 'NOTE'
}
